import React from 'react';
import './SimpleConfetti.css';

const SimpleConfetti = () => {
  const confettiCount = 150;
  const confetti = [];

  const colors = [
    '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5',
    '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4caf50',
    '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800'
  ];

  for (let i = 0; i < confettiCount; i++) {
    const style = {
      left: `${Math.random() * 100}vw`,
      animationDelay: `${Math.random() * 3}s`,
      animationDuration: `${Math.random() * 2 + 3}s`, // 3s to 5s duration
      backgroundColor: colors[Math.floor(Math.random() * colors.length)],
      transform: `rotate(${Math.random() * 360}deg)`
    };
    confetti.push(<div key={i} className="confetti-piece" style={style}></div>);
  }

  return <div className="confetti-container">{confetti}</div>;
};

export default SimpleConfetti;
